import { supabase } from '../supabaseClient'
import { extrairErroEdgeFunction, invokeEdgeFunction } from './edgeFunctionInvoke'

async function consultarFuncao(slug, acao, extra = {}) {
  const usuario = usuarioLogado()
  const { data, error } = await invokeEdgeFunction(slug, {
    acao,
    usuarioId: usuario?.id || '',
    ...extra
  })
  if (error || data?.success === false) {
    const message = await extrairErroEdgeFunction(error, data)
    const falha = new Error(message)
    falha.codigo = data?.codigo || ''
    falha.configurado = data?.configurado !== false && data?.codigo !== 'CREDENCIAIS'
    throw falha
  }
  return data
}

export function consultarGoodwe(acao, extra = {}) {
  return consultarFuncao('goodwe-monitoramento', acao, extra)
}

export function consultarSolplanet(acao, extra = {}) {
  return consultarFuncao('solplanet-monitoramento', acao, extra)
}

function usuarioLogado() {
  try {
    if (localStorage.getItem('isAuthenticated') !== 'true') return null
    const bruto = localStorage.getItem('usuario')
    return bruto ? JSON.parse(bruto) : null
  } catch {
    return null
  }
}

export async function consultarCredenciais(acao, extra = {}) {
  const { data } = await supabase.auth.getSession()
  const usuario = usuarioLogado()
  return consultarFuncao('monitoramento-credenciais', acao, {
    ...extra,
    accessToken: data?.session?.access_token || '',
    usuarioId: usuario?.id || ''
  })
}
